<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12 mb-4">
                <teeth-map :value="teethNumbers" :tooths="[]" :width="20"></teeth-map>
            </div>
            <div v-for="(group, index) in data.teeth" :key="index" :class="Object.keys(group.teethColors).length >= 3 ? 'col-6':'col-4'">
                <div class="row">
                    <div class="col-12">
                        <div class="text-center mb-4" v-if="group.treatment && Object.keys(group.treatment).length > 0">
                            <p class="mb-0">{{$t('Kind of work')}}</p>
                            <h4 class="text-muted mt-2">
                                <strong>{{group.treatment.code}} - </strong>
                                <em>{{group.treatment.label}}</em>
                            </h4>
                        </div>
                    </div>
                    <div v-if="group.teethColors && Object.keys(group.teethColors).length" class="col-12 text-center">
                        <template v-for="(tooth, index) in group.teeth">
                            <div v-if="group.teethColors[tooth]" style="display: inline-block" :key="index">
                                <span v-if="Object.keys(group.teethColors).length > 1" class="badge badge-pill badge-light m-2">
                                    {{ tooth }}
                                </span>
                                <div class="card card--paint">
                                    <div class="card-body">
                                        <paint :value="group.teethColors[tooth]"
                                            width="100px"
                                            height="100px"
                                            readonly
                                            class="mt-2 mb-2">
                                        </paint>
                                        <div class="text-muted" style="min-height: 22px;">
                                            <template v-for="item in group.teethColors[tooth]">
                                                {{item}}
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-auto mb-4" v-if="data.dueDate || data.fittings">
                        <blockquote class="blockquote mb-2" v-if="data.dueDate">
                            <p class="mb-2">{{$t('Completion date')}}</p>
                            <footer class="blockquote-footer">
                                <cite class="text-capitalize" style="font-size: 0.9375rem">{{dateFormatHandler(data.dueDate)}}</cite>
                            </footer>
                        </blockquote>

                        <blockquote class="blockquote mb-0" v-if="data.fittings && data.fittings.length > 0">
                            <p class="mb-2">{{$t('Fittings')}}</p>
                            <footer class="blockquote-footer" v-for="(fitting, fittingIndex) in data.fittings" :key="fittingIndex">
                                <cite class="text-capitalize" style="font-size: 0.9375rem">{{dateFormatHandler(fitting.date)}}</cite>
                            </footer>
                        </blockquote>
                    </div>
                    <div class="col-auto mb-4" v-if="data.forSending.length > 0">
                        <blockquote class="blockquote mb-2">
                            <p class="mb-2">{{$t('For sending')}}</p>
                            <footer class="blockquote-footer text-lowercase" v-for="(sendingItem, index) in data.forSending" :key="index">
                                <cite style="font-size: 0.9375rem">{{sendingItem.text}} {{sendingItem.qty}}</cite>
                            </footer>
                        </blockquote>
                    </div>
                    <div class="col mb-4 pr-5" v-if="data.note || data.faceShape">
                        <blockquote class="blockquote mb-2" v-if="data.faceShape">
                            <p class="mb-2">{{$t('Face shape')}}</p>
                            <footer class="blockquote-footer">
                                <cite style="font-size: 0.9375rem">{{$t(capitalize(data.faceShape))}}</cite>
                            </footer>
                        </blockquote>
                        <blockquote class="blockquote mb-2" v-if="data.note">
                            <p class="mb-2">{{$t('Wishes')}}</p>
                            <footer class="blockquote-footer text-justify"><cite style="font-size: 0.9375rem">{{data.note}}</cite></footer>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-for="(group, index) in data.teeth" :key="index">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">{{$t('Additional')}}</div>
                    <div class="card-body">
                        <table class="table table-bordered labs-print-table">
                            <tbody>
                                <tr class="labs-print-table-info" v-if="group.colorStump">
                                    <td>
                                        <span class="text-muted">{{$t('The color of the stump')}}:</span>
                                    </td>
                                    <td>
                                        {{group.colorStump}}
                                    </td>
                                </tr>
                                <tr class="labs-print-table-info" v-if="group.colorMainTeeth">
                                    <td>
                                        <span class="text-muted">{{$t('The main color of the tooth')}}:</span>
                                    </td>
                                    <td>
                                        {{group.colorMainTeeth}}
                                    </td>
                                </tr>
                                <tr class="labs-print-table-info" v-if="group.colorGums">
                                    <td>
                                        <span class="text-muted">{{$t('The color of the gums')}}:</span>
                                    </td>
                                    <td>
                                        {{group.colorGums}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.implantCrownOption">
                                    <td>
                                        <span class="text-muted">{{$t('Implant crowns')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(capitalize(group.implantCrownOption))}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.systemName">
                                    <td>
                                        <span class="text-muted">{{$t('System name')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(group.systemName)}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.diameter">
                                    <td>
                                        <span class="text-muted">{{$t('Diameter')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(group.diameter)}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.abutmentType">
                                    <td>
                                        <span class="text-muted">{{$t('Abutment type')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(group.abutmentType)}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.notEnoughSpace">
                                    <td>
                                        <span class="text-muted">{{$t('When there is not enough space')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(group.notEnoughSpace)}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.paintOption">
                                    <td>
                                        <span class="text-muted">{{$t('Paint restoration')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(capitalize(group.paintOption))}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.temporaryRestoration">
                                    <td>
                                        <span class="text-muted">{{$t('Temporary restoration')}}:</span>
                                    </td>
                                    <td>
                                        {{$t(capitalize(group.temporaryRestoration))}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.missingTooth">
                                    <td>
                                        <span class="text-muted">{{$t('In the missing tooth area')}}:</span>
                                    </td>
                                    <td>
                                        {{group.missingTooth}}
                                    </td>
                                </tr>

                                <tr class="labs-print-table-info" v-if="group.ovoidImpression">
                                    <td>
                                        <span class="text-muted">{{$t('Form an ovoid impression on the model')}}:</span>
                                    </td>
                                    <td>
                                        {{group.ovoidImpression}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card" v-if="group.frame !== undefined">
                    <div class="card-header">
                        {{$t("Frame")}}
                    </div>
                
                    <div class="card-body">
                        <frame-select unselectable width="35px" height="30px" :value="group.frame"></frame-select>
                    </div>
                </div>

                <div class="card" v-if="group.shoulder !== undefined">
                    <div class="card-header">
                        {{$t("Shoulder")}}
                    </div>
                
                    <div class="card-body">
                        <shoulder :label="true" :tooltip="false" unselectable width="30px" height="30px" :value="group.shoulder"></shoulder>
                    </div>
                </div>

                <div class="card" v-if="group.intermediate !== undefined">
                    <div class="card-header">
                        {{$t('Design of intermediate part')}}
                    </div>

                    <div class="card-body">
                        <intermediate unselectable width="30px" height="30px" :value="group.intermediate"></intermediate>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" v-if="data.images">
                <div v-if="data.images.length > 0" class="card">
                    <div class="card-header"> {{$t("Image")}} </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-3 mb-4" v-for="(image, imageIndex) in data.images" :key="imageIndex">
                                <div class="card mb-0" v-if="image.image">
                                    <img :src="image.image.preview" class="card-img-top" alt="..."/>
                                    <div class="card-body p-2">
                                        <div class="row">
                                            <div class="col text-left"></div>
                                            <div class="col-auto">
                                                <button class="btn btn-white" @click="openFullImageModal(image)">
                                                    <i class="fe fe-eye"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <full-image-modal id="FullImageModal"></full-image-modal>
    </div>
</template>

<script>
import { modalMixins } from '@/mixins/modal.js'
import Modal from "@/components/Modal.vue";

import Paint from "@/components/Lab/Paint/Paint";
import Shoulder from "@/components/Lab/Shoulder/ShoulderSelect";
import FrameSelect from "@/components/Lab/Frame/FrameSelect";
import Intermediate from "@/components/Lab/Intermediate/IntermediateSelect";
import FullImageModal from './FullImageModal'
import TeethMap from '@/components/Teeth/Map';

export default {
    name: "InfoBlock",
    props: {
        value: { type: Object, default: () => ({}) },
    },
    mixins: [modalMixins],
    components: {
        Paint,
        Modal,
        Shoulder,
        TeethMap,
        FrameSelect,
        Intermediate,
        FullImageModal,
    },
    data() {
        return {}
    },
    computed: {
        data: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
                this.$emit('change', value)
            }
        },
        teethNumbers() {
            return this.value.teeth.map(group=>(group.teeth.map(toothNumber=>(toothNumber))))[0];
        }
    },
    methods: {
        openFullImageModal(image) {
            const { Medium } = this.$FeathersVuex;
            new Medium({
                image,
                _id: 'temp'
            });
            this.openModal({id: 'FullImageModal'});
        },

        capitalize(string) {
            return string[0].toUpperCase() + string.slice(1)
        },

        dateFormatHandler(string) {
            return this.$moment(string).format('DD MMMM, YYYY');
        },
    }
}
</script>

<style lang="scss" scoped>
    .labs-print-table {
        &-heading {
            text-align: center;
            background: #f9fbfd;
            color: #95aac9;
            font-weight: 900;
            td {
                padding: 10px 0;
                font-size: 14px;
            }
        }
        &-info {
            td {
                padding: 5px;
                text-align: left;
                &:first-child {
                    width: 30%;
                }
                &:last-child {
                    width: 70%;
                    text-align: left;
                }
            }
        }
        &-content {
            td {
                padding: 0;
            }
        }
    }
</style>
